/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2524
 */

var r = require(/* 1448 */"./1448/index")
module.exports = function (e, t, n) {
  var i = null == e ? undefined : r(e, t)
  return undefined === i ? n : i
}
